var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotpassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "baseline-lock-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baseline-lock-24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "23 7.5 121.5 7.5 121.5 106 23 106"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.8125,80 L128.96875,80 L128.96875,68.2857143 C128.96875,52.12 115.87875,39 99.75,39 C83.62125,39 70.53125,52.12 70.53125,68.2857143 L70.53125,80 L64.6875,80 C58.259375,80 53,85.2714286 53,91.7142857 L53,150.285714 C53,156.728571 58.259375,162 64.6875,162 L134.8125,162 C141.240625,162 146.5,156.728571 146.5,150.285714 L146.5,91.7142857 C146.5,85.2714286 141.240625,80 134.8125,80 Z M99.75,132.5 C93.2875,132.5 88,127.2125 88,120.75 C88,114.2875 93.2875,109 99.75,109 C106.2125,109 111.5,114.2875 111.5,120.75 C111.5,127.2125 106.2125,132.5 99.75,132.5 Z M118,80.5 L81.5,80.5 L81.5,68.7352941 C81.5,58.6764706 89.6830645,50.5 99.75,50.5 C109.816935,50.5 118,58.6764706 118,68.7352941 L118,80.5 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotpassword);
export default __webpack_public_path__ + "static/media/forgotpassword.d5141ad4617a53e73fef6b4690f0a0ec.svg";
export { ForwardRef as ReactComponent };